import createReducer from '../utils/createReducer';
import {
  NETWORK_OK,
  NETWORK_FAILURE,
} from '../constants/actions';

const initialState = {
  isOK: true,
  isNotOK: false,
};

export default createReducer(initialState, {
  [NETWORK_OK]: () => ({
    isOK: true,
    isNotOK: false,
  }),
  [NETWORK_FAILURE]: () => ({
    isOK: false,
    isNotOK: true,
  }),
});



// WEBPACK FOOTER //
// ./src/reducers/network.js